import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Table } from "react-bootstrap";
import { Tooltip, IconButton } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
import { useContractWrite } from "wagmi";
import { waitForTransaction, writeContract } from "@wagmi/core";
import { parseEther } from "viem";
import toast from "react-hot-toast";
import Papa from "papaparse";
import axios from "axios";
import { getPendingWithdrawList, URLApi } from "../../../services/api_function";
import {
  MetheriumToken,
  MetheriumTokenAbi,
  MultisendContract,
  MultisendContractAbi,
  TOKEN_ABI,
  UsdtToken,
  UsdtTokenAbi
} from "../../../config/config";
import web3, { Web3 } from "web3";
export const PendingWithdraw = () => {
  const [apiData, setApiData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [TotalUsers, setTotalUsers] = useState(0);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isApproving, setIsApproving] = useState(false);
  const [isApprovingusdt, setIsApprovingUsdt] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isSendingUsdt, setIsSendingUsdt] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copy address");
  const [approveLoading, setapproveLoading] = useState({});
  const [rejectLoading, setrejectLoading] = useState({});
  const handleSearch = (e) => {
    const query = e.target.value.trim().toLowerCase();
    setSearch(query);
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Copy address"), 2000);
  };

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      const result = await getPendingWithdrawList(
        currentPage,
        40,
        search,
        token
      );
      setApiData(result?.data?.users || []);
      setTotalPages(result?.data?.pagination?.totalPages || 1);
      setTotalUsers(result?.data?.pagination?.totalUsers);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, search]);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleCheckboxChange = (data, event) => {
    if (event.target.checked) {
      setSelectedUsers((prev) => [...prev, data]);
    } else {
      setSelectedUsers((prev) => prev.filter((user) => user._id !== data._id));
    }
  };

  const toggleSelectAll = () => {
    if (selectedUsers.length == apiData.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(apiData);
    }
  };




  // const handleTrnaztionUsdt = async () => {
  //   console.log("called_Function");

  //   if (selectedUsers.length === 0) {
  //     toast.error("No users selected");
  //     return;
  //   }
  //   const recipients = selectedUsers.map((data) => data.user);
  //   const amounts = selectedUsers.map((data) =>
  //     (data.usdtAmount * 0.95).toString()
  //   );


  //   const totalAmount = selectedUsers
  //     .reduce((total, data) => total + data.usdtAmount * 0.98, 0)
  //     .toString();

  //   const refreshAmount = selectedUsers
  //     .reduce((total, data) => total + data.usdtAmount * 1.1, 0)
  //     .toString();

  //   const id = selectedUsers.map((item) => item._id);

  //   const formattedRefreshAmount = (Number(refreshAmount) * 1e18).toString();

  //   console.log(formattedRefreshAmount, "refreshAmount");

  //   try {
  //     setIsApprovingUsdt(true);

  //     const approveTx = await writeContract({
  //       address: UsdtToken,
  //       abi: UsdtTokenAbi,
  //       functionName: "approve",
  //       args: [MultisendContract, formattedRefreshAmount],
  //     });
  //     console.log(approveTx, "approvalData");
  //     const approvalData = await waitForTransaction({ hash: approveTx.hash });
  //     console.log(approvalData, "approvalData");

  //     const multiSendTx = await writeContract({
  //       address: MultisendContract,
  //       abi: MultisendContractAbi,
  //       functionName: "multisendToken",
  //       args: [
  //         recipients,
  //         amounts.map(amount => (Number(amount) * 1e18).toString()),
  //         (Number(totalAmount) * 1e18).toString(),
  //         "0x55d398326f99059fF775485246999027B3197955",
  //       ],
  //     });

  //     console.log("Transaction sent for multisend", multiSendTx);

  //     const multiSendHash = await waitForTransaction({ hash: multiSendTx.hash });

  //     if (multiSendHash) {
  //       console.log(multiSendHash, "multisend transaction hash", id, "user IDs");

  //       try {
  //         const response = await axios.post(URLApi + "/approve-withdId", {
  //           txHash: multiSendHash,
  //           id: id,
  //         });

  //         console.log("API Response:", response.data);
  //         toast.success("Transaction successful and API called!");
  //       } catch (error) {
  //         console.log(error, "Error in the API request");
  //         toast.error("Error calling API");
  //       }
  //     }

  //     setIsSendingUsdt(false);
  //     toast.success("Transaction successful");

  //   } catch (error) {
  //     setIsApprovingUsdt(false); // Hide approval state on error
  //     setIsSendingUsdt(false);   // Hide sending state on error
  //     console.error("Transaction failed", error);
  //     toast.error("Transaction failed");
  //   }
  // };
  // const handleTransaction = async () => {
  //   if (selectedUsers.length === 0) {
  //     toast.error("No users selected");
  //     return;
  //   }

  //   const recipients = selectedUsers.map((data) => data.user);
  //   const amounts = selectedUsers.map((data) =>
  //     (data.mether_amount * 0.95).toString()
  //   );
  //   const totalAmount = selectedUsers
  //     .reduce((total, data) => total + data.mether_amount * 0.98, 0)
  //     .toString();
  //   const refreshAmount = selectedUsers
  //     .reduce((total, data) => total + data.mether_amount * 1.1, 0)
  //     .toString();

  //   const id = selectedUsers.map((item) => item._id);

  //   const formattedRefreshAmount = (Number(refreshAmount) * 1e18).toLocaleString(
  //     "fullwide",
  //     { useGrouping: false }
  //   );

  //   console.log(formattedRefreshAmount, "refreshAmount");

  //   try {
  //     setIsApproving(true);

  //     const approveTx = await writeContract({
  //       address: MetheriumToken,
  //       abi: MetheriumTokenAbi,
  //       functionName: "approve",
  //       args: [MultisendContract, formattedRefreshAmount],
  //     });

  //     await waitForTransaction({ hash: approveTx.hash });

  //     setIsApproving(false);
  //     setIsSending(true);

  //     const multiSendTx = await writeContract({
  //       address: MultisendContract,
  //       abi: MultisendContractAbi,
  //       functionName: "multisendToken",
  //       args: [
  //         recipients,
  //         amounts.map((amount) =>
  //           (Number(amount) * 1e18).toLocaleString("fullwide", {
  //             useGrouping: false,
  //           })
  //         ),
  //         (Number(totalAmount) * 1e18).toLocaleString("fullwide", {
  //           useGrouping: false,
  //         }),
  //         "0x02dDF03c01c5558cd1C5BaBA564cc1852F5906bD",
  //       ],
  //     });

  //     const hash = await waitForTransaction({ hash: multiSendTx.hash });

  //     if (hash) {
  //       try {
  //         const response = await axios.post(URLApi + "/approve-withdId", {
  //           txHash: hash,
  //           id: id,
  //         });

  //         console.log("API Response:", response.data);
  //         toast.success("Transaction successful and API called!");
  //       } catch (error) {
  //         console.log(error, "Error in the apisend()");
  //       }
  //     }

  //     setIsSending(false);
  //     toast.success("Transaction successful");
  //   } catch (error) {
  //     setIsApproving(false);
  //     setIsSending(false);
  //     console.error("Transaction failed", error);
  //     toast.error("Transaction failed");
  //   }
  // };


  const handleTransaction = async () => {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(MultisendContractAbi, MultisendContract);
    const token = new web3.eth.Contract(UsdtTokenAbi, UsdtToken);
    const networkId = await web3.eth.getChainId();


    console.log("in BEP 20 2");
    try {
      setIsApprovingUsdt(true);
      console.log("in BEP 20 3");
      const resp = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      console.log("in BEP 20 4", resp);
      const accounts = await web3.eth.getAccounts();
      console.log("in BEP 20 5");
      const senderAddress = accounts[0];
      console.log("in BEP 20 6", senderAddress);
      const recipients = selectedUsers.map((data) => data.user);
      const amounts = selectedUsers.map((data) => data.mether_amount * 0.95);
      const id = selectedUsers.map((data) => data._id.toString().slice(0, 1));
      const objid = selectedUsers.map((data) => data._id);
      const totalAmount = web3.utils.toWei(
        selectedUsers
          .reduce((total, data) => total + data.mether_amount * 0.98, 0)
          .toString(),
        "ether"
      );

      const refreshamount = web3.utils.toWei(
        selectedUsers
          .reduce((total, data) => total + data.mether_amount * 1.1, 0)
          .toString(),
        "ether"
      );

      const amountsInWei = amounts.map((amount) =>
        web3.utils.toWei(amount.toString(), "ether")
      );
      const gasPrice = await web3.eth.getGasPrice();

      console.log("Recipients:", recipients);
      console.log("Amounts (in Wei):", amountsInWei);
      console.log("Total Amount:", totalAmount);
      console.log("IDs:", id);
      console.log("Sender Address:", senderAddress);

      const balance = await web3.eth.getBalance(senderAddress);
      const balanceInEther = web3.utils.fromWei(balance, "ether");
      console.log(`Sender balance: ${balanceInEther} ETH`);

      try {
        const tokengas = await token.methods
          .approve(MetheriumToken, refreshamount)
          .estimateGas({ from: senderAddress });

        console.log(`Estimated gas for approve: ${tokengas}`);

        const approve = await token.methods
          .approve(MultisendContract, refreshamount)
          .send({
            from: senderAddress,
            gas: tokengas,
            gasPrice: gasPrice,
          });

        console.log("Approval successful:", approve);
        toast.success("Approve successful");
      } catch (approveError) {
        console.error("Approve failed:", approveError);
        toast.error("Approval transaction failed");
        throw approveError;
      }

      try {
        console.log(
          0,
          recipients,
          amountsInWei,
          totalAmount,
          "0x02dDF03c01c5558cd1C5BaBA564cc1852F5906bD"
        );
        const gas = await contract.methods
          .multisendToken(
            recipients,
            amountsInWei,
            totalAmount,
            "0x02dDF03c01c5558cd1C5BaBA564cc1852F5906bD"
          )
          .estimateGas({ from: senderAddress });

        console.log(`Estimated gas for multisendToken: ${gas}`);

        const receipt = await contract.methods
          .multisendToken(
            recipients,
            amountsInWei,
            totalAmount,
            "0x02dDF03c01c5558cd1C5BaBA564cc1852F5906bD"
          )
          .send({
            from: senderAddress,
            gas: gas,
            gasPrice: gasPrice,
          });

        console.log("Transaction receipt:", receipt);

        try {
          const apiResponse = await fetch(URLApi + "/approve-withdId", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${token2}`,
            },
            body: JSON.stringify({
              txHash: receipt.transactionHash,
              user: recipients,
              id: objid,
            }),
          });

          const responseBody = await apiResponse.json();
          console.log("API Response:", responseBody);

          if (apiResponse.status === 200) {
            fetchData();
            toast.success(
              "Transaction successful",
              apiResponse.message
            );
            setIsApprovingUsdt(false);
            window.location.reload();
          } else {
            setIsApprovingUsdt(false);
            toast.error("Failed to send transaction data");
          }
        } catch (apiError) {
          setIsApprovingUsdt(false);
          console.error("API Error:", apiError);
          toast.error("API call failed");
        }
      } catch (multisendError) {
        setIsApprovingUsdt(false);
        console.error("Multisend failed:", multisendError);
        toast.error("Multisend transaction failed");
      }
    } catch (error) {
      setIsApprovingUsdt(false);
      console.error("Transaction failed:", error);
      toast.error("Transaction failed");
    }

  };


  const handleTrnaztionUsdt = async () => {
    const web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(MultisendContractAbi, MultisendContract);
    const token = new web3.eth.Contract(UsdtTokenAbi, UsdtToken);
    const networkId = await web3.eth.getChainId();


    console.log("in BEP 20 2");
    try {
      setIsApprovingUsdt(true);
      console.log("in BEP 20 3");
      const resp = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      console.log("in BEP 20 4", resp);
      const accounts = await web3.eth.getAccounts();
      console.log("in BEP 20 5");
      const senderAddress = accounts[0];
      console.log("in BEP 20 6", senderAddress);
      const recipients = selectedUsers.map((data) => data.user);
      const amounts = selectedUsers.map((data) => data.usdtAmount * 0.95);
      const id = selectedUsers.map((data) => data._id.toString().slice(0, 1));
      const objid = selectedUsers.map((data) => data._id);
      const totalAmount = web3.utils.toWei(
        selectedUsers
          .reduce((total, data) => total + data.usdtAmount * 0.98, 0)
          .toString(),
        "ether"
      );

      const refreshamount = web3.utils.toWei(
        selectedUsers
          .reduce((total, data) => total + data.usdtAmount * 1.1, 0)
          .toString(),
        "ether"
      );

      const amountsInWei = amounts.map((amount) =>
        web3.utils.toWei(amount.toString(), "ether")
      );
      const gasPrice = await web3.eth.getGasPrice();

      console.log("Recipients:", recipients);
      console.log("Amounts (in Wei):", amountsInWei);
      console.log("Total Amount:", totalAmount);
      console.log("IDs:", id);
      console.log("Sender Address:", senderAddress);

      const balance = await web3.eth.getBalance(senderAddress);
      const balanceInEther = web3.utils.fromWei(balance, "ether");
      console.log(`Sender balance: ${balanceInEther} ETH`);

      try {
        const tokengas = await token.methods
          .approve(MultisendContract, refreshamount)
          .estimateGas({ from: senderAddress });

        console.log(`Estimated gas for approve: ${tokengas}`);

        const approve = await token.methods
          .approve(MultisendContract, refreshamount)
          .send({
            from: senderAddress,
            gas: tokengas,
            gasPrice: gasPrice,
          });

        console.log("Approval successful:", approve);
        toast.success("Approve successful");
      } catch (approveError) {
        console.error("Approve failed:", approveError);
        toast.error("Approval transaction failed");
        throw approveError;
      }

      try {
        console.log(
          0,
          recipients,
          amountsInWei,
          totalAmount,
          "0x55d398326f99059ff775485246999027b3197955"
        );
        const gas = await contract.methods
          .multisendToken(
            recipients,
            amountsInWei,
            totalAmount,
            "0x55d398326f99059ff775485246999027b3197955"
          )
          .estimateGas({ from: senderAddress });

        console.log(`Estimated gas for multisendToken: ${gas}`);

        const receipt = await contract.methods
          .multisendToken(
            recipients,
            amountsInWei,
            totalAmount,
            "0x55d398326f99059ff775485246999027b3197955"
          )
          .send({
            from: senderAddress,
            gas: gas,
            gasPrice: gasPrice,
          });

        console.log("Transaction receipt:", receipt);

        try {
          const apiResponse = await fetch(URLApi + "/approve-withdId", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${token2}`,
            },
            body: JSON.stringify({
              txHash: receipt.transactionHash,
              user: recipients,
              id: objid,
            }),
          });

          const responseBody = await apiResponse.json();
          console.log("API Response:", responseBody);

          if (apiResponse.status === 200) {
            fetchData();
            toast.success(
              "Transaction successful",
              apiResponse.message
            );
            setIsApprovingUsdt(false);
            window.location.reload();
          } else {
            setIsApprovingUsdt(false);
            toast.error("Failed to send transaction data");
          }
        } catch (apiError) {
          setIsApprovingUsdt(false);
          console.error("API Error:", apiError);
          toast.error("API call failed");
        }
      } catch (multisendError) {
        setIsApprovingUsdt(false);
        console.error("Multisend failed:", multisendError);
        toast.error("Multisend transaction failed");
      }
    } catch (error) {
      setIsApprovingUsdt(false);
      console.error("Transaction failed:", error);
      toast.error("Transaction failed");
    }

  }


  const handleReject = async (user, _id, amount, wallet_type) => {
    setapproveLoading({ ...approveLoading, [user]: true });
    const userDetails = localStorage.getItem("userDetails");
    const parsedDetails = JSON.parse(userDetails);
    const token = parsedDetails.token;
    const apiResponse = await fetch(URL + "/reject-withdraw", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        user: user,
        amount: amount,
        id: _id,
        wallettype: wallet_type
      }),
    });

    if (apiResponse.status == 200) {
      const errorMessage = await apiResponse.json();
      setapproveLoading(false);
      toast.success(errorMessage.message);
      fetchData();
      window.location.reload();
    } else {
      if (apiResponse.status == 400) {
        const errorMessage = await apiResponse.json();
        setapproveLoading(false);
        toast.error(errorMessage.message);
      } else {
        toast.error("Failed to send transaction data");
        setapproveLoading(false);
      }
    }
  };
  return (
    <Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>All USERS</Card.Title>
            </Card.Header>
            <Card.Body>

              <button
                onClick={handleTransaction}
                disabled={isApproving || isSending}
                className="btn btn-danger m-2 p-2"
              >
                {isApproving || isSending
                  ? "Processing..."
                  : "Approve & Send Metherium"}
              </button>

              <button
                onClick={handleTrnaztionUsdt}
                disabled={isApprovingusdt || isSendingUsdt}
                className="btn btn-danger m-2 p-2"
              >
                {isApprovingusdt || isSendingUsdt
                  ? "Processing..."
                  : "Approve & Send Usdt"}
              </button>
              <Table responsive>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={selectedUsers.length == apiData.length}
                        onClick={toggleSelectAll}
                      />
                    </th>
                    <th>S.No.</th>
                    <th>User Wallet</th>
                    <th>Payemnt Type</th>
                    <th>Wallet Type</th>
                    <th>Amount Usdt</th>
                    <th>Amount Mether</th>
                    <th>Fees 5%</th>
                    <th>Total</th>
                    <th>Reject</th>
                    <th>Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {!apiData.length ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No Records Found
                      </td>
                    </tr>
                  ) : (
                    apiData.map((data, index) => (
                      <tr key={data._id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedUsers.some(
                              (u) => u._id == data._id
                            )}
                            onChange={(event) =>
                              handleCheckboxChange(data, event)
                            }
                          />
                        </td>
                        <td>{index + 1}</td>
                        <td>
                          {data?.user?.slice(0, 8)}...{data?.user?.slice(-9)}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton
                              onClick={() => handleCopy(data?.user)}
                              size="small"
                            >
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td>
                        <td>{(data?.payment_method || "")}</td>
                        <td>{(data?.wallet_type || "")}</td>
                        <td>{(data?.usdtAmount)?.toFixed(2)}</td>
                        <td>{(data?.mether_amount)?.toFixed(2)}</td>
                        <td>{(data?.mether_amount == 0 ? (data?.usdtAmount * 0.05) : (data?.mether_amount * 0.05))?.toFixed(2)}</td>
                        <td>{(data?.mether_amount == 0 ? (data?.usdtAmount * 0.95) : (data?.mether_amount * 0.95))?.toFixed(2)}</td>
                        <td>
                          {" "}
                          <button
                            style={{
                              cursor: "pointer",
                              padding: "5px 10px",
                              color: "white",
                              backgroundColor: "red",
                              fontWeight: "bold",
                              border: "none",
                              borderRadius: "4px",
                              outline: "none",
                            }}
                            onClick={() =>
                              handleReject(
                                data.user,
                                data._id,
                                data.usdtAmount,
                                data.wallet_type
                              )
                            }
                            disabled={approveLoading[data.user]}
                          >
                            {rejectLoading[data.user]
                              ? "Rejecting..."
                              : "Reject"}
                          </button>
                        </td>
                        <td>{new Date(data?.createdAt).toLocaleString()}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              <div
                className="col-lg-6 text-center mb-3"
                style={{ margin: "auto" }}
              >
                <div className="filter-pagination mt-3">
                  <button
                    className="btn border m-2 previous-button"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  <button
                    type="button"
                    className="btn btn-success border m-2 next-button pointer"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>

                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <span> Total users {TotalUsers}</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default PendingWithdraw;
